module.exports = __webpack_public_path__ + "img/orange1.29803a00.png";